import React from 'react'
import ActionButton from '../../../../library/input/buttons/button/SarasButton'

const DocEditAction = (props) => {
    const { formObject, viewData, rowID, reloadSearch } = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const dtId = formObject.getValueFromKey(viewData, "dataList.valLDT", "");
    const companyId = formObject.getValueFromKey(viewData, "dataList.cId", "");

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch();
    }
    
    const onEditClick = (e) => {
        let customAction = { actionId: "edit", skipMasterKey: 1, containerKey: "popup" };

        customAction.onModalClose = onPopupClose;
        customAction["actionParam"] = { "dId":viewData.val, "dtId": dtId, "cId":companyId, showModeID:"sh" };
        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", "");

        if (customAction.actionId) formObject.onFormAction(customAction, rowID, "");
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                <ActionButton onClick={onEditClick} 
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiLink uiIcon"
                className={''} />
            </div>
        </div>
    )
}

export default DocEditAction